_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
BaseDirectoryView = require './base-directory-view'
BoardAddToTeam = require 'app/scripts/views/board-menu/board-add-to-team-view'
Controller = require 'app/scripts/controller'
{ dontUpsell } = require '@trello/config'
ModelLoader = require 'app/scripts/db/model-loader'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('directory')
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'

class DirectoryBusinessClassBanner extends React.Component
  displayName: 'Directory Business Class Banner'

  render: t.renderable ->
    { onDismissClick, onUpgradeClick } = @props

    t.div '.directory-business-class-banner', ->
      t.div '.banner-content', ->
        t.icon 'business-class', class: 'icon-lg light'
        t.format 'this-board-has-reached-its-power-up-limit-upgrade-to-business-class-to-enable-additional-power-ups'
      t.div '.buttons-container', ->
        t.a '.dismiss-link', { href: '#', onClick: onDismissClick }, ->
          t.format 'dismiss'
        t.a '.button-link.mod-upgrade', { href: '#', onClick: onUpgradeClick }, ->
          t.format 'upgrade'

class DirectoryHeader extends React.Component
  displayName: 'Directory Header'

  render: t.renderable ->
    { title, showBackButton, navigateBack, toggleNavigationMenu } = @props

    t.div '.directory-header', ->
      t.div '.directory-header-toolbar', ->
        t.h2 '.directory-header-toolbar-title', ->
          t.format title
        t.div '.directory-header-toolbar-left', ->
          t.a '.icon-lg.icon-back.dark-hover.directory-back-btn', { href: '#', onClick: navigateBack, class: t.classify({ 'hide': !showBackButton }) }
          t.a '.directory-hamburger', { href: '#', onClick: toggleNavigationMenu }, ->
            t.text '☰'
        t.div '.directory-header-toolbar-right', ->
          t.a '.icon-lg.icon-close.dark-hover.js-close-directory', { href: '#' }

class DirectoryHeaderComponent extends React.Component
  render: t.renderable ->
    { title, showBackButton, navigateBack, toggleNavigationMenu, upsellEnabled, onUpgradeClick, onDismissClick } = @props
    t.div ->
      t.tag DirectoryHeader, { title, showBackButton, navigateBack, toggleNavigationMenu }
      if upsellEnabled
        t.tag DirectoryBusinessClassBanner, { onUpgradeClick, onDismissClick }

module.exports = class DirectoryHeaderView extends BaseDirectoryView
  initialize: ({ @directoryView }) ->
    super
    @listenTo @model, 'change:powerUps': @render
    @listenTo @model.boardPluginList, 'add remove reset': @render
    @subscribe pluginsChangedSignal(@model), => @render()

  onUpgradeClick: (e) ->
    Util.stop(e)
    trackUe('Power-Up BC upgrade banner', 'clicks', 'upgrade button')

    if !@model.owned()
      window.location = '/business-class'
      return
    else if @model.hasOrganization()
      window.location = Controller.getBoardPowerUpsUpgradeUrl(@model)
      return

    ModelLoader.loadMyOrganizations()
    PopOver.toggle
      autoPosition: true
      elem: e.target
      getViewTitle: => 'Upgrade to Business Class'
      view: new BoardAddToTeam({ @model })

  onDismissClick: (e) ->
    Util.stop(e)
    trackUe('Power-Up BC upgrade', 'closes', 'Power-Up BC upgrade banner')

    Auth.me().dismissAd('DirectoryBusinessClassBanner')
    @manuallyDismissed = true
    @render()
    @directoryView.setBodyHeight(@manuallyDismissed)

  renderContent: ->
    { category, section, idPlugin, history, search } = @directoryView

    title = 'power-ups'
    if search? && search.length
      title = 'power-ups'
    else if category?
      title = category
    else if section?
      title = section

    # Specifically checking for BC2 orgs to not show upsell banner
    isPremiumOrg = @model.getOrganization()?.isPremium()

    React.createElement DirectoryHeaderComponent,
      title: title
      upsellEnabled: !@model.canEnableAdditionalPowerUps() && !isPremiumOrg && !(@manuallyDismissed || Auth.me().isAdDismissed('DirectoryBusinessClassBanner')) && !dontUpsell
      showBackButton: section? || idPlugin? || history.length
      navigateBack: => @directoryView.navigateBack()
      onUpgradeClick: (e) => @onUpgradeClick(e)
      onDismissClick: (e) => @onDismissClick(e)
      toggleNavigationMenu: => @directoryView.toggleNavigationMenu()
